<template>
  <el-scrollbar>
    <el-input
      v-model="filterText"
      :placeholder="treePlaceholder ? treePlaceholder : '请输入关键字'"
    />
    <el-tree
      ref="treeRef"
      :data="treeData"
      :filter-node-method="filterNode"
      class="left-tree"
      :node-key="treeNodeKey"
      @node-click="nodeClick"
      :current-node-key="curNode"
      highlight-current
      default-expand-all
    >
      <template #default="{ node }">
        {{ node.label }}
      </template>
    </el-tree>
  </el-scrollbar>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import searchTreeMixin from "./searchTreeMixin";
import { replaceObjectKeys } from "@pansy/utils";

export default defineComponent({
  name: "searchTree",
  mixins: [searchTreeMixin],
  props: {},
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const treeRef = ref();
    const state = reactive({
      treeData: [],
      filterText: null,
      curNode: null,
      treeParams: {}, //当选左边树形条件请求列表的传参
    });
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value.filter(val);
      }
    );
    onMounted(() => {
      getTreeData();
    });
    //树形筛选
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.includes(value);
    };
    //点击树形
    const nodeClick = (node) => {
      state.curNode = node[props.treeNodeKey];
      state.treeParams = props.handleTree ? props.handleTree(node) : node;
      emit("click", node, state.treeParams);
    };
    //获取树形数据
    const getTreeData = (params) => {
      if (props.treeUrl) {
        proxy.$api[props.treeUrl](params, "get").then((res) => {
          state.treeData = props.treeProps
            ? replaceObjectKeys(res.data, props.treeProps, {
                simplify: false,
              })
            : res.data;
        });
      }
    };
    return {
      treeRef,
      ...toRefs(state),
      filterNode,
      nodeClick,
    };
  },
});
</script>
<style scoped lang="less"></style>
